// src/app/redux/actions/offboardingActions.js

// =========================
// OFFBOARDINGS (CRUD)
// =========================
export const FETCH_OFFBOARDINGS_REQUEST = "FETCH_OFFBOARDINGS_REQUEST";
export const FETCH_OFFBOARDINGS_SUCCESS = "FETCH_OFFBOARDINGS_SUCCESS";
export const FETCH_OFFBOARDINGS_FAIL = "FETCH_OFFBOARDINGS_FAIL";

export const GET_OFFBOARDING_REQUEST = "GET_OFFBOARDING_REQUEST";
export const GET_OFFBOARDING_SUCCESS = "GET_OFFBOARDING_SUCCESS";
export const GET_OFFBOARDING_FAIL = "GET_OFFBOARDING_FAIL";

export const CREATE_OFFBOARDING_REQUEST = "CREATE_OFFBOARDING_REQUEST";
export const CREATE_OFFBOARDING_SUCCESS = "CREATE_OFFBOARDING_SUCCESS";
export const CREATE_OFFBOARDING_FAIL = "CREATE_OFFBOARDING_FAIL";

export const UPDATE_OFFBOARDING_REQUEST = "UPDATE_OFFBOARDING_REQUEST";
export const UPDATE_OFFBOARDING_SUCCESS = "UPDATE_OFFBOARDING_SUCCESS";
export const UPDATE_OFFBOARDING_FAIL = "UPDATE_OFFBOARDING_FAIL";

export const DELETE_OFFBOARDING_REQUEST = "DELETE_OFFBOARDING_REQUEST";
export const DELETE_OFFBOARDING_SUCCESS = "DELETE_OFFBOARDING_SUCCESS";
export const DELETE_OFFBOARDING_FAIL = "DELETE_OFFBOARDING_FAIL";

// =========================
// ETAPES (CRUD)
// =========================
export const FETCH_ETAPES_REQUEST = "FETCH_ETAPES_REQUEST";
export const FETCH_ETAPES_SUCCESS = "FETCH_ETAPES_SUCCESS";
export const FETCH_ETAPES_FAIL = "FETCH_ETAPES_FAIL";

export const CREATE_ETAPE_REQUEST = "CREATE_ETAPE_REQUEST";
export const CREATE_ETAPE_SUCCESS = "CREATE_ETAPE_SUCCESS";
export const CREATE_ETAPE_FAIL = "CREATE_ETAPE_FAIL";

export const UPDATE_ETAPE_REQUEST = "UPDATE_ETAPE_REQUEST";
export const UPDATE_ETAPE_SUCCESS = "UPDATE_ETAPE_SUCCESS";
export const UPDATE_ETAPE_FAIL = "UPDATE_ETAPE_FAIL";

export const DELETE_ETAPE_REQUEST = "DELETE_ETAPE_REQUEST";
export const DELETE_ETAPE_SUCCESS = "DELETE_ETAPE_SUCCESS";
export const DELETE_ETAPE_FAIL = "DELETE_ETAPE_FAIL";

// =========================
// UI STATE
// =========================
export const SET_OFFBOARDING_LOADING = "SET_OFFBOARDING_LOADING";
export const CLEAR_OFFBOARDING_ERROR = "CLEAR_OFFBOARDING_ERROR";

export const setOffboardingLoading = (loading) => ({
    type: SET_OFFBOARDING_LOADING,
    payload: loading,
});

export const clearOffboardingError = () => ({
    type: CLEAR_OFFBOARDING_ERROR,
});

// ===== Offboardings
export const fetchOffboardingsRequest = () => ({ type: FETCH_OFFBOARDINGS_REQUEST });
export const fetchOffboardingsSuccess = (data) => ({ type: FETCH_OFFBOARDINGS_SUCCESS, payload: data });
export const fetchOffboardingsFail = (error) => ({ type: FETCH_OFFBOARDINGS_FAIL, payload: error });

export const getOffboardingRequest = (id) => ({ type: GET_OFFBOARDING_REQUEST, payload: id });
export const getOffboardingSuccess = (data) => ({ type: GET_OFFBOARDING_SUCCESS, payload: data });
export const getOffboardingFail = (error) => ({ type: GET_OFFBOARDING_FAIL, payload: error });

export const createOffboardingRequest = (payload) => ({ type: CREATE_OFFBOARDING_REQUEST, payload });
export const createOffboardingSuccess = (created) => ({ type: CREATE_OFFBOARDING_SUCCESS, payload: created });
export const createOffboardingFail = (error) => ({ type: CREATE_OFFBOARDING_FAIL, payload: error });

export const updateOffboardingRequest = (id, payload) => ({
    type: UPDATE_OFFBOARDING_REQUEST,
    payload: { id, payload },
});
export const updateOffboardingSuccess = (updated) => ({ type: UPDATE_OFFBOARDING_SUCCESS, payload: updated });
export const updateOffboardingFail = (error) => ({ type: UPDATE_OFFBOARDING_FAIL, payload: error });

export const deleteOffboardingRequest = (id) => ({ type: DELETE_OFFBOARDING_REQUEST, payload: id });
export const deleteOffboardingSuccess = (id) => ({ type: DELETE_OFFBOARDING_SUCCESS, payload: id });
export const deleteOffboardingFail = (error) => ({ type: DELETE_OFFBOARDING_FAIL, payload: error });

// ===== Etapes
export const fetchEtapesRequest = (offboardingId) => ({ type: FETCH_ETAPES_REQUEST, payload: offboardingId });
export const fetchEtapesSuccess = (offboardingId, etapes) => ({
    type: FETCH_ETAPES_SUCCESS,
    payload: { offboardingId, etapes },
});
export const fetchEtapesFail = (error) => ({ type: FETCH_ETAPES_FAIL, payload: error });

export const createEtapeRequest = (payload) => ({ type: CREATE_ETAPE_REQUEST, payload });
export const createEtapeSuccess = (created) => ({ type: CREATE_ETAPE_SUCCESS, payload: created });
export const createEtapeFail = (error) => ({ type: CREATE_ETAPE_FAIL, payload: error });

export const updateEtapeRequest = (id, payload) => ({ type: UPDATE_ETAPE_REQUEST, payload: { id, payload } });
export const updateEtapeSuccess = (updated) => ({ type: UPDATE_ETAPE_SUCCESS, payload: updated });
export const updateEtapeFail = (error) => ({ type: UPDATE_ETAPE_FAIL, payload: error });

export const deleteEtapeRequest = (id, offboardingId) => ({
    type: DELETE_ETAPE_REQUEST,
    payload: { id, offboardingId },
});
export const deleteEtapeSuccess = (id, offboardingId) => ({
    type: DELETE_ETAPE_SUCCESS,
    payload: { id, offboardingId },
});
export const deleteEtapeFail = (error) => ({ type: DELETE_ETAPE_FAIL, payload: error });
